import { DataFormats } from '@skylab-shared/constants';
import { HttpService, L10nBase, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { FiscalDeviceEventKind, FiscalDeviceEventStatus, SaleDocumentKind } from '@skylab-shared/dataModel';
import { getUnixTimestamp } from '@skylab-shared/utils';
import { format } from 'fecha';
import { PagedCollectionQueryResultDTO } from '../../common/query/paged-collection-query';
import { FiscalDeviceItem } from './fiscal-device.query-base';

export interface FiscalDeviceRegistryItem {
    id: number;
    date: string;
    associatedDocumentId: number;
    associatedDocumentNumber: string;
    associatedDocumentKind: SaleDocumentKind;
    kind: FiscalDeviceEventKind;
    status: FiscalDeviceEventStatus;
    note: string;
}

class FiscalDeviceRegistryInternalItemDTO {
    public readonly date: string;
    public readonly description: string;
    public readonly deviceId: number;
    public readonly document: string;
    public readonly documentId: number;
    public readonly documentKind: SaleDocumentKind;
    public readonly endDate: Date;
    public readonly id: number;
    public readonly kind: FiscalDeviceEventKind;
    public readonly status: FiscalDeviceEventStatus;
    public readonly version: string;
}

export class FiscalDeviceRegistryQuery extends Query<FiscalDeviceRegistryItem[]> { }

export class FiscalDeviceRegistryQueryHandlerBase implements QueryHandler<FiscalDeviceRegistryQuery, FiscalDeviceRegistryItem[]> {

    public constructor(
        private readonly http: HttpService,
        private readonly l10n: L10nBase
    ) { }

    public async handleAsync(_: FiscalDeviceRegistryQuery, device: FiscalDeviceItem): Promise<FiscalDeviceRegistryItem[]> {
        const url = TaggedUrl.join(`system/devices/${device.id}/events`, [Tags.Api]);
        const { data } = await this.http.get(url, {
            dtoObject: new PagedCollectionQueryResultDTO<FiscalDeviceRegistryInternalItemDTO>(FiscalDeviceRegistryInternalItemDTO)
        });

        return data.items
            .map(item => ({...item, date: new Date(item.date)}))
            .sort((a, b) => getUnixTimestamp(b.date) - getUnixTimestamp(a.date))
            .map(e => ({
                id: e.id,
                date: format(e.date, DataFormats.date.dateTime),
                note: e.description,
                associatedDocumentId: e.documentId,
                associatedDocumentNumber: e.document,
                associatedDocumentKind: e.documentKind,
                kind: e.kind,
                status: e.status
            }));
    }
}
